import React, { useEffect, useState } from "react";
import { reset, Field, formValueSelector, reduxForm } from "redux-form";
import { connect } from "react-redux";
import s from "./basketModal.module.css";
import { getFetch, getMessage } from "../../redux/Calc_reducer";
import Loader from "../Loaders/Loader";
import MessageSuccess from "../Messages/MessageSuccess";
import { phoneMask } from "../utils";


let PersonalForm = ({
  fetch,
  dispatch,
  message,
  handleSubmit,
  // hasMail,
  hasFIO,
  hasPhone,
}) => {
  const [messageWindowToggle, setMessageWindowToggle] = useState(false);
  const disabled = !(/*!!hasMail && */!!hasFIO && hasPhone?.length === 10);
  useEffect(() => {
    if (message.length > 0) {
      setMessageWindowToggle(true);
      dispatch(reset("calc"));
      if (message?.substr(0, 3) !== "Не ") dispatch(reset("basketDelivery"));
      dispatch(reset("personalForm"));
    } else {
      setMessageWindowToggle(false);
    }
  }, [message]);
  return (
    (messageWindowToggle && <MessageSuccess message={message} />) ||
    (fetch ? (
      <Loader />
    ) : (
      <form className={s.form} onSubmit={handleSubmit}>
        <div>
          <div className="calc_title">
            Укажите свои контактные данные для связи
          </div>
          <Field
            placeholder={"Имя"}
            type={"text"}
            name={"fio"}
            component={"input"}
          />
          {/*<Field
            placeholder={"E-mail"}
            type={"text"}
            name={"email"}
            value={"123123"}
            component={"input"}
          />*/}
          <Field
            placeholder={"Телефон"}
            type={"tel"}
            {...phoneMask}
            name={"phone"}
            component={"input"}
          />
        </div>
        <button disabled={disabled}>Отправить</button>
      </form>
    ))
  );
};

PersonalForm = reduxForm({
  form: "personalForm",
})(PersonalForm);

const selector = formValueSelector("personalForm");

export default connect((state) => ({
  hasFIO: selector(state, "fio"),
  // hasMail: selector(state, "email"),
  hasPhone: selector(state, "phone"),
  fetch: getFetch(state),
  message: getMessage(state),
}))(PersonalForm);
